export default __webpack_public_path__ + "static/banner-finance-4-questions-d24b5f8454d581a6e9ca6aa94369494f.jpg";